<template>
    <div class="wrapper">
        <div class="page-header page-header-small">
            <parallax class="page-header-image" style="background-image: url('img/mapa.png')">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <h4>Komplexní služby v oblasti odpadového hospodářství.</h4>
                        <h1></h1>
                        <h1 class="title">KONTAKTY</h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="separator-line separator-primary"></div>

        <div class="container">
            <div class="row">
                <div class="col-md-6 ml-auto mr-auto">
                    <div class="card text-center pruhledna">
                        <div class="card-header mt-2">
                        </div>
                        <div class="card-body">
                            <div class="about-contact">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-md-8 mr-auto ml-auto">
                                            <h2 class="text-center title">MINOREC k.s.</h2>
                                            <h4 class="text-center adresa">U Tonasa 172/2</h4>
                                            <h4 class="text-center adresa">403 31 Ústí nad Labem - Neštěmice</h4>
                                            <h4 class="text-center adresa">Česká republika</h4>
                                            <h4 class="text-center"></h4>
                                            <h4 class="text-center adresa"><img src="/img/phone.svg" width="30px" height="30px" alt="">  777 082 183</h4>
                                            <h4 class="text-center"></h4>
                                            <h4 class="text-center adresa"><img src="/img/email.svg" width="30px" height="30px" alt="">  <a href="mailto:info@minorec.cz">info@minorec.cz</a></h4>
                                            <h4 class="text-center"></h4>
                                            <h5 class="text-center adresa">IČ 62 24 20 32</h5>
                                            <h5 class="text-center adresa">Zapsaný v OR u Krajského soudu v Ústí n. L. oddíl A, vložka 5442</h5>
                                            <h5 class="text-center adresa">IČZ: CZU00551</h5>
                                            <h5 class="text-center adresa">IČZ: CZU01016</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-muted mb-2">
                        </div>
                    </div>
                </div>

                <div class="col-md-6 ml-auto mr-auto">
                    <div class="card text-center pruhledna">
                        <div class="card-header mt-2">
                        </div>
                        <div class="card-body">
                            <div class="about-contact">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-md-12 mr-auto ml-auto">
                                            <h2 class="text-center title">Máte dotaz nebo poptávku?</h2>
                                            <h4 class="text-center description">Spojíme se s Vámi co nejdříve.</h4>
                                            <form class="contact-form">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label>Jméno</label>
                                                        <fg-input addon-left-icon="now-ui-icons users_circle-08" v-model="form.name" placeholder=""> </fg-input>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <label>Email</label>
                                                        <fg-input addon-left-icon="now-ui-icons ui-1_email-85" v-model="form.email" placeholder=""> </fg-input>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <label>Telefon</label>
                                                        <fg-input addon-left-icon="now-ui-icons ui-1_bell-53" v-model="form.phone" placeholder=""> </fg-input>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <label>Dotaz</label>
                                                        <fg-input v-model="form.longtext" placeholder="(volitelný text)" > </fg-input>
                                                    </div>

                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4 ml-auto mr-auto text-center">
                                                        <button @click.prevent="send_mail()" class="btn btn-primary btn-round mt-4 btn-lg vyrovnani">
                                                            Odeslat
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="card-footer text-muted mb-2">

                        </div>
                    </div>
                </div>
            </div>
        </div>

    <modal :show.sync="modals.mini"
            class="modal-success"
            :show-close="false"
            header-classes="justify-content-center"
            type="mini">
    <div slot="header" class="modal-profile d-flex justify-content-center align-items-center">
        <i class="now-ui-icons users_circle-08"></i>
    </div>
    <p>Děkujeme za odeslání, brzy se ozveme.</p>
    <template slot="footer">
        <n-button type="neutral" link @click.native="modals.mini = false">Close</n-button>
    </template>
    </modal>

    <modal :show.sync="modals.chyba"
            class="modal-danger"
            :show-close="false"
            header-classes="justify-content-center"
            type="mini">
    <div slot="header" class="modal-profile d-flex justify-content-center align-items-center">
        <i class="now-ui-icons users_circle-08"></i>
    </div>
    <p>Nevyplněny kontaktní údaje, ověřte laskavě formulář.</p>
    <p>Povinné je jméno a k němu email nebo telefon.</p>
    <template slot="footer">
        <n-button type="neutral" link @click.native="modals.chyba = false">Close</n-button>
    </template>
    </modal>

    </div>
</template>
<script>
  import { Button, FormGroupInput, Checkbox, Modal } from '@/components';
  import { Select, Option } from 'element-ui';
  import axios from 'axios';

  export default {
    name: 'stahnout',
    bodyClass: 'stahnout',
    components: {
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      [Select.name]: Select,
      [Option.name]: Option,
      [Modal.name]: Modal,
    },
    data() {
      return {
        form: {
          name: '',
          email: '',
          phone: '',
          longtext: ''
        },
        imgSrc: "img/card_8145342.jpg",
        modals: {
            mini: false,
            chyba: false
        }
      }
    },
    methods: {
        send_mail: function() {
            if ((this.form.name) && ((this.form.email) || (this.form.phone))) {
				fetch('https://minorec.cz/api/send-email/', {
					method: 'POST',
					mode: 'cors',
					cache: 'no-cache',
					credentials: 'same-origin',
					headers: {
						'Content-Type': 'application/json'
					},
					redirect: 'follow',
					referrerPolicy: 'no-referrer',
					body: JSON.stringify({
						privat_api_key: "minorec_secret_code",
						subject: "Dotaz/poptavka z webu MINOREC",
						name: this.form.name,
						email: this.form.email,
						phone: this.form.phone,
						longtext: this.form.longtext,
					}),
				})
                .then(response => {
                    this.modals.mini = true;
                    this.form.name = "";
                    this.form.email = "";
                    this.form.phone = "";
                    this.form.longtext = "";
                })
            }
            else {
                this.modals.chyba = true;
            }
        }

    }


  }
</script>
<style>
.section {
    padding: 0 0 !important;
}

.about-us {
    padding: 0 0 !important;
}
.about-description, .about-contact {
    padding: 0 0 !important;
}
.features-3 {
    padding: 0 0 !important;
}
.description {
    color: #888 !important;
    font-weight: 500 !important;
}
.maxtitle {
    color: white !important;
    font-size: 50px !important;
    font-weight: 900 !important;
    padding-top: 0px !important;
}
.vytahnout {
    margin-top: -8vh;
}

.pruhledna {
    opacity: 0.9;
}

.page-header, .page-header-small {
    min-height: 40vh !important;
    max-height: 300px;
}

.maxtitle1 {
    padding-top: 60px !important;
}

.adresa {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
    font-size: 14px !important;

}
.vyrovnani {
    margin-bottom: 25px !important;
}

</style>
